import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Subtitle from "ui/text/Subtitle";

import Calendar from './Calendar';
import Location from './Location';

import useSliderController from 'utils/useSliderController';
import TicketList from './TicketList';
import Sessions from './Sessions';

const Header = ({image_url, title, start_date, end_date, location, tickets, eventProducts, onAction, showApplicationFee, single, sessions, requires_approval, ticketSlug, cartMode}) => {

  const showSessions = !single && sessions && sessions.length > 0 && !ticketSlug;

  const [selectedSession, setSelectedSession] = useState(showSessions ? sessions[0] : null );

  const { handleImageClick, SliderComponent} = useSliderController();

  const shownTickets = selectedSession ? selectedSession.tickets : tickets;

  // Uniformize thumbnails across tickets AND products: if any card in the event
  // has an image, every card reserves the thumb slot so the list stays aligned.
  const hasImage = (item) => Array.isArray(item.image_urls) && item.image_urls.length > 0;
  const showThumb = [...(shownTickets || []), ...(eventProducts || [])].some(hasImage);

  return (
    <div className="event-header">

      <div className='sub-header'>
        
        <img src={image_url} alt={title} onClick={() => handleImageClick([image_url])} />
      
        <div>
          <Subtitle>{title}</Subtitle>
        
          {single && <Calendar start_date={start_date} end_date={end_date} />}

          {location && <Location location={location} />}
        </div>
      </div>

      {showSessions && <Sessions sessions={sessions} selectedSession={selectedSession} onChange={setSelectedSession}/>}

      <TicketList tickets={shownTickets || []} products={eventProducts || []} showApplicationFee={showApplicationFee} onAction={onAction} requires_approval={requires_approval} cartMode={cartMode} showThumb={showThumb}/>

      <SliderComponent />
    </div>
  );
};

Header.propTypes = {
    image_url: PropTypes.string,
    title: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    location: PropTypes.string,
    tickets: PropTypes.array,
    eventProducts: PropTypes.array,
    onAction: PropTypes.func,
    showApplicationFee: PropTypes.bool,
    single: PropTypes.bool,
    sessions: PropTypes.array,
    requires_approval: PropTypes.bool,
    ticketSlug: PropTypes.string,
    cartMode: PropTypes.bool
};

export default Header;
